module.exports = __webpack_public_path__ + "img/transfer25.d08340ff.jpeg";